<template>
    <div class="person-card">
        <table class="table table-bordered table-sm">
            <thead class="thead-orange">
                <tr class="x-d-flex">
                    <th colspan="2">Información Persona</th>
                </tr>
            </thead>
            <tbody>
                <tr class="x-d-flex">
                    <td><strong>Foto</strong></td>
                    <td>
                        <div v-if="person.photo" class="col-12 col-sm-6 avatar" :style="'background-image: url(' + person.photo + ')'">
                        </div>
                        <div v-if="!person.photo">
                           -- No hay Foto --
                        </div>
                    </td>
                </tr>
                <tr class="x-d-flex">
                    <td><strong>Nombre</strong></td>
                    <td>{{ person.name }}</td>
                </tr>
                <tr v-if="!isVigilance" class="x-d-flex">
                    <td><strong>Documento</strong></td>
                    <td>{{ person.document }}</td>
                </tr>
                <tr v-if="!isVigilance" class="x-d-flex">
                    <td><strong>E-mail</strong></td>
                    <td>{{ person.email }}</td>
                </tr>
                <tr v-if="!isVigilance" class="x-d-flex">
                    <td><strong>Empresa</strong></td>
                    <td>{{ person.company }}</td>
                </tr>
                <tr v-if="!isVigilance" class="x-d-flex">
                    <td><strong>Cargo</strong></td>
                    <td>{{ person.position }}</td>
                </tr>
                <tr v-if="!isVigilance" class="x-d-flex">
                    <td><strong>Teléfono</strong></td>
                    <td>{{ person.phone }}</td>
                </tr>
                <tr class="x-d-flex">
                    <td><strong>Interno / Visitante</strong></td>
                    <td>{{ !!person.internal? 'Interno': 'Visitante' }}</td>
                </tr>
            </tbody>
        </table>
    </div>
</template>
<script>
    export default {
        props: {
            person: {
                type: Object,
                required: true
            }
        },

        data(){
            return{
                isVigilance: false
            }
        },

        created(){
            this.isVigilance = this.user.profile.slug === 'vigilante' ? true: false;
        }

    }
</script>
<style>

</style>
